import React from 'react';
import { findDOMNode } from 'react-dom';
import { TimelineLite } from 'gsap';
import 'gsap/src/uncompressed/plugins/ScrollToPlugin';

export default {

	setVars(PriceCheckerForm) {
		this.node = findDOMNode(PriceCheckerForm);
		this.loader = this.node.querySelector('.loader');
		this.error = this.node.querySelector('.error-msg');
		this.btn = this.node.querySelector('.fibre-submit-btn');
		this.disclaimer = this.node.querySelector('.disclaimer1');
		// On Success:
		this.animateOut = this.node.querySelector('.animate-out');
		this.animateUp = this.node.querySelector('.animate-up');
		this.plansContainer = this.node.querySelector('.plans-container');
		this.planButtons = this.node.querySelector('.plans-container .buttons');
		this.resultRows = this.node.querySelectorAll('.plans-container .responsive-table table tr');
		this.notice = this.node.querySelector('.notice');
		// Buttons
		this.speedBtns = [...this.node.querySelectorAll('.speed-btn')];
	},
    
    reset(PriceCheckerForm) {
        this.setVars(PriceCheckerForm);

        this.loader.style.display = 'none';
		this.btn.style.display = 'block';

        let labels = [...this.node.getElementsByClassName('input__label')],
            graphics = [...this.node.getElementsByClassName('graphic--nao')],
            formRows = [...this.node.getElementsByClassName('form-row')];

        labels.map(item => {
            item.style.color = '#004346';
        });

        graphics.map(item => {
            item.style.stroke = '#004346';
        });

        formRows.map(item => {
            item.style.display = 'block';
        });
    },

    showLoader(PriceCheckerForm) {
		this.setVars(PriceCheckerForm);

		this.btn.style.display = 'none';
		this.error.style.display = 'none';
		this.plansContainer.style.visibility = 'hidden';
        this.loader.style.display = 'block';
    },

    showSuccess(PriceCheckerForm) {
		this.setVars(PriceCheckerForm);
		let tl = new TimelineLite(),
			form = this.node.querySelector('form'),
			animateUpOffset = (form.offsetTop - this.animateUp.offsetTop);

		this.loader.style.display = 'none';
		this.error.style.display = 'none';
		this.btn.style.display = 'none';
		this.disclaimer.style.display = 'none';

		tl.to(this.animateOut, 0.5, {y: -300, opacity: 0});
		tl.to(this.animateUp, 0.5, {y: animateUpOffset}, 0);
		tl.addLabel('reset', 0.5);
		tl.set(this.animateOut, {display: 'none'}, 'reset');
		tl.set(this.animateUp, {y: 0, marginTop: '30px'}, 'reset');
		tl.add(() => {
			this.plansContainer.style.display = 'block';
			this.plansContainer.style.visibility = 'visible';
		});
		tl.staggerFromTo(this.resultRows, 0.40, {opacity: 0}, {opacity: 1, ease: Power2.easeOut}, 0.1);
		tl.fromTo(this.planButtons, 0.25, {opacity: 0, y: -50}, {opacity: 1, y: 0});
		if (this.notice) {
			tl.fromTo(this.notice, 0.3, {opacity: 0, scale: 0.5}, {opacity: 1, scale: 1, delay: 1.5});
		}
    },

    showErrors(PriceCheckerForm) {
		this.setVars(PriceCheckerForm);

        this.loader.style.display = 'none';
        this.error.style.display = 'block';
		this.btn.style.display = 'block';
		[...this.node.getElementsByClassName('form-row')].map(item => {
			item.style.display = 'block';
		});
    },

	showError(PriceCheckerForm, selector) {
		this.setVars(PriceCheckerForm);
		let tl = new TimelineLite(),
			container = this.node.querySelector(selector);

		this.loader.style.display = 'none';
		this.btn.style.display = 'block';
		this.node.querySelector('form').style.visibility = 'hidden';
		tl.set(container, {display: 'flex', opacity: 0});
		tl.to(container, 0.5, {opacity: 1});
	},

	closeError(PriceCheckerForm, selector) {
		this.setVars(PriceCheckerForm);
		let tl = new TimelineLite(),
			container = this.node.querySelector(selector);

		this.node.querySelector('form').style.visibility = 'visible';
		tl.to(container, 0.25, {opacity: 0});
		tl.set(container, {display: 'none', opacity: 1});
        this.reset(PriceCheckerForm);
	},

	setActive(target) {
		[...document.querySelectorAll('.speed-btn')].map(item => {
			item.classList.remove('active');
		});

		target.classList.add('active');
	},

	toggleSpeedButtons(inProgress) {
		if (inProgress) {
			this.speedBtns.forEach(item => {
				item.style.opacity = 0.5;
			});
		} else {
			this.speedBtns.forEach(item => {
				item.style.opacity = 1;
			});
		}
	}

}


// WEBPACK FOOTER //
// ./resources/assets/js/forms/PriceCheckerForm/animations.js